<template>
  <K2Row align="center" class="k2Radio">
    <el-radio v-model="radio" :label="item" @change="onChange" v-for="item in list">{{ item }}</el-radio>
  </K2Row>
</template>

<script>
import K2Row from '../k2Row/k2Row'
import './k2Radio.scss'

export default {
  name: 'K2Radio',
  components: { K2Row },
  props: ['input', 'list', 'passValue'],
  data() {
    return {
      radio: '8%',
    }
  },
  mounted() {
    this.radio = this.passValue
  },
  methods: {
    onChange() {
      this.$emit('input', this.radio)
    },
  },
}
</script>
